var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProcessingFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3261_5616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7159 10.5165L8.76483 1.40175C8.39115 0.772676 7.73118 0.396973 6.99946 0.396973C6.26775 0.396973 5.60778 0.772676 5.2341 1.40175C5.23128 1.40656 5.2289 1.41137 5.22609 1.41618L0.291523 10.502C-0.0901681 11.1444 -0.0973868 11.9158 0.271863 12.5653C0.641961 13.2153 1.30871 13.603 2.05648 13.603H11.9151C12.6629 13.603 13.357 13.2153 13.7271 12.5653C14.0963 11.9158 14.0892 11.1444 13.7159 10.5165ZM6.17833 4.57042C6.17833 4.1169 6.54597 3.74929 6.99946 3.74929C7.45299 3.74929 7.8206 4.11693 7.8206 4.57042V7.85498C7.8206 8.30845 7.45296 8.67611 6.99946 8.67611C6.54597 8.67611 6.17833 8.30842 6.17833 7.85498V4.57042ZM6.99946 11.9607C6.32027 11.9607 5.76774 11.4082 5.76774 10.729C5.76774 10.0498 6.32025 9.49727 6.99946 9.49727C7.67866 9.49727 8.23116 10.0498 8.23116 10.729C8.23119 11.4082 7.67868 11.9607 6.99946 11.9607Z",
    fill: "#606975"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3261_5616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcessingFailed);
export default __webpack_public_path__ + "static/media/icon-processing-failed.af6bc1e1bbd5c80cebf8020ffbc03008.svg";
export { ForwardRef as ReactComponent };